import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {  listAllCaseAdministrativeOutput } from '../../../services/cases-admin.service';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-available-cases-admin',
  templateUrl: './available-cases-admin.component.html',
  styleUrls: ['./available-cases-admin.component..scss']
})
export class AvailableCasesAdminComponent implements OnInit {
  tableColumns: string[] = ['name', 'contact', 'createdAt', 'acoes'];
  dataSource = new MatTableDataSource<listAllCaseAdministrativeOutput>();

  constructor() { }

  @Output() 
  edit = new EventEmitter<number>();

  @Output()
  inactivateCase = new EventEmitter<number>();

  @Output()
  pageChange = new EventEmitter<PageEvent>();
  
  @Input()
  data: listAllCaseAdministrativeOutput[] = [];

  @Input()
  loading: boolean;

  @Input()
  pageLength: number;

  @Input()
  total: number;

  ngOnInit(): void {}

  ngOnChanges():void {
    this.data.forEach(item => {
      const date = new Date(Number(item.createdAt));

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      item.createdAtString = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    });

    this.dataSource.data = this.data;
  }
}
